import React from "react"
import MenuRightIcon from "mdi-react/MenuRightIcon"
import MenuDownIcon from "mdi-react/MenuDownIcon"

import "./accordion.scss"

class Accordion extends React.Component {
  constructor(props) {
    super()
    this.state = {
      open: false || props.open,
    }
  }

  click = () => {
    this.setState({ open: !this.state.open })
  }

  render() {
    return (
      <div
        className={`accordion-component ${this.props.className || ""}  ${this
          .state.open && "open"}`}
        onClick={this.click}
      >
        <div className="header">
          <h4>{this.props.title}</h4>
          <div className="grow" />
          {this.state.open ? <MenuDownIcon /> : <MenuRightIcon />}
        </div>
        <div className="body">
          <p className="answer">{this.props.body}</p>
          {this.props.resources.length > 0 && (
            <React.Fragment>
              <p className="resources-title">Resources: </p>
              <ul className="resources">
                {this.props.resources.map(resource => (
                  <li className="resource">
                    <span className="resource-description">
                      {resource.description}
                    </span>{" "}
                    <a
                      className="resource-link"
                      href={resource.url}
                      target="_blank"
                    >
                      {resource.label}
                    </a>
                  </li>
                ))}
              </ul>
            </React.Fragment>
          )}
        </div>
      </div>
    )
  }
}

export default Accordion
